export default "__VITE_ASSET__DanRJnoq__"